export const REQUESTER_TYPES = {
  USER: 'users',
  TEAM: 'teams',
  COMPANY: 'companies',
};

export default {
  REQUESTER_TYPES,
};
